<script setup>
import {
  NSpace,
  NSlider,
  NDropdown,
  NIcon,
  NButton,
  NPopconfirm,
  useMessage,
  NInput,
} from "naive-ui";
// import { options } from "@/baseData/dpi.js";
import { reqInitData } from "../baseData/system";
import { reportParams, mouseDevice } from "@/common";
import { ref, onMounted, watch, onUnmounted } from "vue";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { getCheckSum, sendReport } from "../common/index.js";
import { language } from "@/hooks/util/i18n";
const main = useStore();
const message = useMessage();
const { device, init, indexData, languageValue, changeSetting } =
  storeToRefs(main);
const options = ref([
  { label: "第1档", key: 2, value: 400 },
  { label: "第2档", key: 3, value: 800 },
  { label: "第3档", key: 4, value: 1600 },
  { label: "第4档", key: 5, value: 3200 },
  { label: "第5档", key: 6, value: 6400 },
  { label: "第6档", key: 7, value: 10000 },
  { label: "第7档", key: 8, value: 20000 },
]);

const defaultData = ref([]);
const selectedValue = ref({
  label: "第1档",
  key: 2,
});
const colorArray = ref([
  [
    {
      label: 400,
      color: "rgb(199 105 105)",
      activeColor: "#ff0000",
      key: 2,
      value: "第1档",
      isDisabled: false,
    },
    {
      label: 800,
      color: "#137b18",
      activeColor: "#00ff00",
      key: 3,
      value: "第2档",
      isDisabled: false,
    },
    {
      label: 1600,
      color: "#13157c",
      activeColor: "#0000ff",
      key: 4,
      value: "第3档",
      isDisabled: false,
    },
  ],
  [
    {
      label: 3200,
      color: "#7a157d",
      activeColor: "#ff00ff",
      key: 5,
      value: "第4档",
      isDisabled: false,
    },
    {
      label: 6400,
      color: "#137b7e",
      activeColor: "#00ffff",
      key: 6,
      value: "第5档",
      isDisabled: false,
    },
  ],
]);
const currentDpi = ref(0);

// 获取Dpi
watch(changeSetting, async (newValue) => {
  if (newValue) {
    const arr = newValue.split(" ");
    const dpiValue = parseInt(arr[9], 16);
    const rateValue = parseInt(arr[10], 16);

    if (currentDpi.value !== dpiValue) {
      let { reportId, reportData } = reportParams(
        reqInitData + getCheckSum(reqInitData)
      );

      await device.value.sendReport(reportId, reportData);
    }
  }
});

const handleSelect = (key) => {
  (selectedValue.value.label = `第1档`), (selectedValue.value.key = 2);
  currentDpi.value = key;
  for (let i = 0; i < colorArray.value.length; i++) {
    for (let j = 0; j < colorArray.value[i].length; j++) {
      if (colorArray.value[i][j].key > key) {
        colorArray.value[i][j].isDisabled = true;
      } else {
        colorArray.value[i][j].isDisabled = false;
      }
    }
  }
};

onMounted(async () => {
  if (device.value) {
    // 读取鼠标的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    // 发送数据

    await device.value.sendReport(reportId, reportData);
  }
});
onUnmounted(() => {
  main.initData("");
  main.addDpi("");
  
});
const currentRate = ref();
const currentScrollDirect = ref();
watch(indexData, (newValue, oldValue) => {
  if (!newValue) {
    // console.log("已经有初始值");
    return;
  }
  defaultData.value = [];
  const arr = newValue.split(" ");
  currentRate.value = arr[6];
  currentScrollDirect.value = arr[5];
  const obj = {
    "01": 2,
    "03": 3,
    "07": 4,
    "0f": 5,
    "1f": 6,
    "0F": 5,
    "1F": 6,
  };

  currentDpi.value = obj[arr[7]];

  for (let i = 0; i < colorArray.value.length; i++) {
    for (let j = 0; j < colorArray.value[i].length; j++) {
      if (colorArray.value[i][j].key > obj[arr[7]]) {
        colorArray.value[i][j].isDisabled = true;
      } else {
        colorArray.value[i][j].isDisabled = false;
      }
    }
  }

  let count = 0;
  let str = "";
  for (let i = 1; i < 61; i++) {
    str += arr[i];
    count++;
    if (count === 4) {
      defaultData.value.push(str);
      count = 0;
      str = "";
    }
  }
  const num = mouseDevice() === "v2" ? 8 : 0;
  defaultData.value[0] = num === 8 ? "04 00 a5 02" : "04 00 ad 02";

  const current = parseInt(defaultData.value[1].slice(-1), 16);
  selectedValue.value = { label: `第${current + 1}档`, key: current + 2 };
  for (let i = 2; i < 9; i++) {
    const num1 = parseInt(defaultData.value[i].slice(0, 2), 16);
    const num2 = parseInt(defaultData.value[i].slice(2, 4), 16) * 256;
    options.value[i - 2].value = num1 + num2;
  }
  // console.log("arr", defaultData.value);
});
const setting = () => {
  const pos = ["01", "03", "07", "0f", "1f", "1f", "1f"];
  console.log(defaultData.value);
  defaultData.value[1] =
    currentScrollDirect.value +
    currentRate.value +
    pos[currentDpi.value - 2] +
    "0" +
    (selectedValue.value.key - 2);
  for (let i = 0; i < options.value.length - 2; i++) {
    const index = options.value[i].key;
    const value = options.value[i].value;
    const data =
      (value % 256).toString(16).padStart(2, "0") +
      Math.floor(value / 256)
        .toString(16)
        .padStart(2, "0");
    defaultData.value[index] = data + data;
  }
  const str = "00" + defaultData.value.join("") + "000000";
  const value = str + getCheckSum(str);
  // console.log(value)
  try {
    sendReport(value);
    message.success(language[languageValue.value]["设置成功"]);
  } catch {
    message.error("设置失败,请检查设备是否连接");
  }
};

const reset = async () => {
  options.value[0].value = 400;
  for (let i = 1; i < options.value.length; i++) {
    if (i !== 5 && i !== 6) {
      options.value[i].value = options.value[i - 1].value * 2;
    } else if (i === 5) {
      options.value[i].value = 10000;
    } else {
      options.value[i].value = 20000;
    }
  }
  // 重置DPI的数据
  if (device.value) {
    const dpiData =
      "000400ad0271021f01900190012003200340064006800c800c0019001910271027204e204e010000000000000807080706000000000000000000000000000000";
    let { reportId, reportData } = reportParams(dpiData + getCheckSum(dpiData));
    // 发送数据
    const sendData =
      "000a0081010000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
    setTimeout(async () => {
      try {
        let { reportId: id, reportData: data } = reportParams(
          sendData + getCheckSum(sendData)
        );
        // 发送数据
        await device.value.sendReport(id, data);
        handleSelect(6);
      } catch (err) {}
    }, 100);
    await device.value.sendReport(reportId, reportData);
  }
};
const numberChange = (num) => {
  if (!Number(num) && Number(num) !== 0) {
    return;
  }
  let number = Number(num);
  const maxNum = mouseDevice() === "v2" ? 30000 : 26000;
  if (number > maxNum) {
    number = maxNum;
  }
  options.value[selectedValue.value.key - 2].value = Number(number);
};
const numberBlur = () => {
  const count = Math.floor(
    options.value[selectedValue.value.key - 2].value / 50
  );
  options.value[selectedValue.value.key - 2].value = count * 50;
  if (options.value[selectedValue.value.key - 2].value === 0) {
    options.value[selectedValue.value.key - 2].value = 100;
  }
};
const handleClick = ({ key, value, isDisabled }) => {
  if (isDisabled) return;
  selectedValue.value.label = value;
  selectedValue.value.key = key;
};
watch(
  options,
  (newValue) => {
    colorArray.value[0][0].label = newValue[0].value;
    colorArray.value[0][1].label = newValue[1].value;
    colorArray.value[0][2].label = newValue[2].value;
    colorArray.value[1][0].label = newValue[3].value;
    colorArray.value[1][1].label = newValue[4].value;
  },
  { deep: true }
);
// onMounted(() => {
//   if (document.getElementById("slider")) {
//     document.getElementById("slider").style.zoom = 1 / document.body.style.zoom;
//   }
// });
</script>

<template>
  <div class="bg">
    <div class="linear" style="margin-top: 24px"></div>
    <div class="top1">
      <n-dropdown
        trigger="hover"
        placement="bottom-start"
        :options="
          options.slice(0, 5).map((item) => ({
            ...item,
            label: language[languageValue][item.label],
          }))
        "
        @select="handleSelect"
        :inverted="true"
      >
        <img src="@/images/dpi/dpi-icon1.png" alt="" />
      </n-dropdown>
      <div class="middle">
        {{ language[languageValue]["DPI调节"] }}({{
          language[languageValue][selectedValue.label]
        }})
      </div>
      <n-popconfirm
        @positive-click="reset"
        :positive-text="language[languageValue]['是']"
        :negative-text="language[languageValue]['否']"
        :show-icon="false"
        trigger="hover"
      >
        <template #trigger>
          <img
            src="@/images/dpi/dpi-icon2.png"
            alt=""
            style="cursor: pointer"
          />
        </template>
        {{ language[languageValue]["是否重置DPI为默认值"] }}
      </n-popconfirm>
    </div>
    <div class="linear"></div>
    <div class="content">
      <div>
        <div style="margin-bottom: 16px">
          <span class="title">{{ language[languageValue]["固定数值"] }}</span>
        </div>
        <div v-for="(item, index) in colorArray" :key="index" class="flex">
          <span
            v-for="(i, j) in item"
            :style="{
              backgroundColor:
                i.key === selectedValue.key ? i.activeColor : i.color,
            }"
            :class="i.isDisabled ? 'disabled' : ''"
            class="number"
            @click="handleClick(i)"
            >{{ i.label }}</span
          >
        </div>
        <div class="line"></div>
        <div class="title" style="margin-bottom: 18px">
          {{ language[languageValue]["指针设置"] }}
        </div>
        <div style="margin-bottom: 20px; display: flex" class="dpi">
          <span class="numberValue">{{
            language[languageValue]["目前数值"]
          }}</span>
          <n-input
            size="tiny"
            style="
              width: 65px;
              box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
              background: linear-gradient(
                90deg,
                rgba(37, 91, 103, 1),
                rgba(37, 91, 103, 1)
              );
              margin-left: 20px;
              border-radius: 3px;
              text-align: center;
            "
            :value="String(options[selectedValue.key - 2].value)"
            @update-value="numberChange"
            @blur="numberBlur"
          />
          <!-- <span
            style="
              padding: 2px 15px;
              box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
              background: linear-gradient(
                90deg,
                rgba(37, 91, 103, 1),
                rgba(37, 91, 103, 1)
              );
              margin-left: 20px;
              border-radius: 3px;
            "
            >{{ options[selectedValue.key - 2].value }}</span
          > -->
        </div>

        <div style="display: flex; justify-content: center">
          <div
            style="
              width: 28px;
              height: 420px;
              background: linear-gradient(0deg, #000c1a, #255b67);
            "
          >
            <!--  -->
            <n-slider
              :tooltip="false"
              vertical
              v-model:value="options[selectedValue.key - 2].value"
              :min="50"
              :max="mouseDevice() === 'v2' ? 30000 : 26000"
              :marks="
                mouseDevice() === 'v2'
                  ? { 50: '50', 30000: '30000' }
                  : { 50: '50', 26000: '26000' }
              "
              :step="50"
              id="slider"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="setting">
      <n-button type="info">{{ language[languageValue]["确认设置"] }}</n-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.bg {
  position: relative;
  width: 288px;
  // background-color: #ccc;

  color: #fff;
  .disabled {
    background-color: #808080 !important;
  }
  .dpi {
    /deep/ .n-input {
      --n-border: 0px !important;
      --n-border-hover: 0px !important;
      --n-border-focus: 0px !important;
    }

    /deep/ .n-input__input-el {
      color: #fff;
    }
  }
  .title {
    font-family: "PingFang";
    font-weight: bold;
    font-size: 14px;
    color: #b5d8f1;
  }
  .content {
    padding: 32px;
    height: 670px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    background: linear-gradient(
      90deg,
      rgba(19, 52, 71, 0.22),
      rgba(2, 12, 22, 0.22)
    );
    // background-color: rgba(255, 255, 255, 0.11);
    // opacity: .58;
    box-sizing: border-box;
  }
  .linear {
    width: 288px;
    height: 3px;
    background: linear-gradient(90deg, #457287, #387d8c, #385d65);
  }
  .top1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(66deg, #020612, #16221e);
    margin-bottom: 16px;

    height: 64px;
    border-bottom-right-radius: 15px;
    padding: 0 18px 0 26px;
    .middle {
      font-family: "PingFang";
      font-weight: bold;
      font-size: 17px;
      color: #b5d8f1;
    }
  }
  .top {
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    text-align: center;
    background-color: #15211d;
  }
  .btn {
    position: absolute;
    right: 20px;
    margin-top: 20px;
    .n-button {
      background: linear-gradient(66deg, #020612, #16221e);
    }
  }
  .numberValue {
    font-family: PingFang;
    font-weight: bold;
    font-size: 14px;
    color: #637077;
  }
}
.flex {
  display: flex;
  //justify-content: space-between;
  margin-bottom: 12px;
  .number:not(:last-child) {
    margin-right: 29px;
  }
  .number {
    width: 55px;
    display: block;
    box-sizing: border-box;
  }
}
.line {
  width: 265px;
  height: 2px;
  background: linear-gradient(90deg, #000c1a, #255b67);
  margin-left: -20px;
  margin-bottom: 19px;
}
.number {
  display: inline-block;
  width: 57px;
  height: 18px;
  line-height: 18px;
  padding-left: 5px;
  box-sizing: border-box;
  // margin-right: 29px;

  border-radius: 3px;
  cursor: pointer;
  font-family: "PingFang";
  font-weight: 500;
  font-size: 14px;
  color: #fff;
}
</style>
